import { render } from "./Agreements.vue?vue&type=template&id=90c1cad6&ts=true"
import script from "./Agreements.vue?vue&type=script&lang=ts"
export * from "./Agreements.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__